export const SET_SELECTED_STATUS = 'selectedStatus';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_DATA_ENTRADA_INICIAL = 'dataEntradaInicial';
export const SET_DATA_ENTRADA_FINAL = 'dataEntradaFinal';
export const SET_COMPRADOR = 'comprador';

